import { COMMITMENT_PACING_PAGE, PORTFOLIO_CASHFLOW_PROJECTIONS_PAGE, PORTFOLIO_PAGE } from "./routes";
export const getPortfolioCashflowProjectionsPageUrl = (portfolioId, workspaceId) => {
    if (workspaceId) {
        return PORTFOLIO_CASHFLOW_PROJECTIONS_PAGE
            .replace(":id", portfolioId)
            .replace(":workspaceId", workspaceId);
    }
    return PORTFOLIO_PAGE.replace(":id", portfolioId);
};
export const getCommitmentPacingPageUrl = (portfolioId) => COMMITMENT_PACING_PAGE.replace(":id", portfolioId);
